export default class AdwordsGoogleDiscovery {
  constructor(context) {
    this.context = context;
    this.axios = this.context.$axios;
  }
  // BUMPER
  async getGoogleDiscovery(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate,
    customerId
  ) {
    try {
      const googleDiscovery = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL_GOOGLE}/adwords/DEMAND_GEN/${customerId}/businesses/${businessUnitId}?fromDate=${fromDate}&toDate=${toDate}`
      );

      return {
        ...googleDiscovery.data
      };
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }

  async getGoogleDiscoveryBudget(
    subscriberId,
    businessUnitId,
    fromDate,
    toDate
  ) {
    try {
      const result = await this.axios.get(
        `${process.env.VUE_APP_API_BASE_URL}/adwords/budget/${subscriberId}/businesses/${businessUnitId}?fromDate=${fromDate}&toDate=${toDate}`
      );

      return result.data[0].budget;
    } catch (err) {
      console.log(`Fallo la peticion:${err}`);
    }
  }
}
